import { releases } from "@/mocks/comic";

export default function NewReleases() {
  return (
    <section id="new" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-upload-cloud-2-line"></i>
              新作速递
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              热门连载 · 抢先同步
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              新作上线实时更新，画质筛选后统一入库，第一时间找到清晰的高清静态漫画图源。
            </p>
          </div>
          <a
            href="#quality"
            className="inline-flex items-center gap-1 text-sm font-medium whitespace-nowrap text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部更新
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-6">
          {releases.map((r) => (
            <article
              key={r.id}
              className="group cursor-pointer overflow-hidden rounded-2xl border border-background-200/70 bg-background-100 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={r.image}
                  alt={`${r.title} 高清漫画封面图`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
                <span className="absolute bottom-3 left-3 translate-y-2 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium whitespace-nowrap text-primary-600 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                  查看图源
                </span>
              </div>
              <div className="p-3">
                <h3 className="truncate text-sm font-medium text-foreground-950">
                  {r.title}
                </h3>
                <div className="mt-1.5 flex items-center justify-between text-xs text-foreground-600">
                  <span>{r.episode}</span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line"></i>
                    {r.date}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}